import React from 'react';
import {List, ListItem} from 'material-ui/List';
import {CardTitle, Card, CardText} from 'material-ui/Card';
import Button from 'material-ui/RaisedButton';
import {Link} from 'react-router';
import PropTypes from 'prop-types';
import InfluenceAvatar from './InfluenceAvatar';
import {domainLogicToCounts} from '../reducer/response';
import NoteIcon from "material-ui/svg-icons/action/find-in-page";
import {noteIconColor} from "../components/resultItems/Notes";

class InfluentialAnswersList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    let props = this.props;
    let {responseID} = this.props;
    let answers = props.answers.slice(0, 6);

    return (
      <List>
        <Card initiallyExpanded={true}>
          <CardTitle showExpandableButton={true} title="Influential Answers" subtitle="These answers caused the strongest caveats and/or eliminated the most options in this section." />
          <CardText expandable={true}>
            {
              answers.map((answer) => {
                let rightIcon = answer.note ? <NoteIcon color={noteIconColor} /> : null;

                let question = answer.question
                let qTitle = question.title
                let answerText = props.answerTextLookup[question.id]
                if(props.translation){
                  var trQ = this.props.translation.questions.find(trQ => trQ.engID === question.id)
                  if(trQ){
                      qTitle = trQ.title
                      let answerID = question.answers.find(a => a.title === answerText).id
                      answerText = trQ.answers.find(a => a.id === answerID).title
                  }
                }

                return <ListItem
                  key={answer.question.id}
                  leftAvatar={
                    //pass null to options so that it includes all options for the section in count and not whatever is filtered to the screen
                    <InfluenceAvatar display={true || this.props.section !== 'assessment' ? "Caveat" : "Criteria"} {...domainLogicToCounts(answer.question, answer.value, props.options, props.section)} />
                  }
                  primaryText={qTitle.replace(/<.*?>/gm, '')}
                  secondaryText={answerText}
                  onClick={this.onItemClick.bind(this, answer.question.id)}
                  rightIcon={rightIcon}
                />
              })
            }

            <Button containerElement={<Link to={`/questionnaire/results/${responseID}/answers`} />} label="See all Answers" />
          </CardText>
        </Card>
      </List>
    )
  }

  scoreTouchTap(id, e) {
    this.setState({
      openInfluentialQuestionID: id
    });
    e.stopPropagation();
  }

  onItemClick(id) {
    if (this.props.onItemClick) {
      this.props.onItemClick(id);
    }
  }
}

InfluentialAnswersList.propTypes = {
  answers: PropTypes.array.isRequired,
}

export default InfluentialAnswersList;
